// removed by extract-text-webpack-plugin
module.exports = {"jumpLinksOuterContSticky":"JumpLinks__jumpLinksOuterContSticky","jumpLinksOuterCont":"JumpLinks__jumpLinksOuterCont","jumpLinksCont":"JumpLinks__jumpLinksCont","jumpLinksRow":"JumpLinks__jumpLinksRow","jumpLinksBtn":"JumpLinks__jumpLinksBtn","jumpLinksBtnInner":"JumpLinks__jumpLinksBtnInner","jumpLinksBtnBlk":"JumpLinks__jumpLinksBtnBlk","jumpLinksBtnDkGry":"JumpLinks__jumpLinksBtnDkGry","jumpLinksUnderline":"JumpLinks__jumpLinksUnderline","jumpLinksUnderlineTransition":"JumpLinks__jumpLinksUnderlineTransition"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/containers/JumpLinks/JumpLinks.scss
// module id = 1845
// module chunks = 8